export const APP_AGE_GROUP = '4-8' as string;
